import useScreenWidth from 'features/common/hooks/useScreenWidth'
import Desktop from './desktop'
import Mobile from './mobile'

const PortalRoot = () => {
    const {isMobile} = useScreenWidth()
    if (isMobile) {
        return <Mobile />
    }
    return <Desktop />
}

export default PortalRoot
